<template>
  <BUTTON :alignment="'left'" :button-state="buttonState" :data="data" :width="100"></BUTTON>
</template>

<script>
import BUTTON from './BUTTON';

export default {
  name: 'ANZBUTTONFULL',

  components: {
    BUTTON
  },

  props: {
    buttonState: {
      type: Object,
      required: false,
      default: () => {
        return {
          disabled: false
        };
      }
    },

    data: {
      type: Object,
      required: true
    }
  }
};
</script>
